// Redux Action Types
import { SET_USER_PROFILE } from '../actions/types';
// Initial State
const initialState = null;

export default function (state = initialState, action) {
  if (action.type === SET_USER_PROFILE) return action.payload;
  return state;
}
